/**
 * ч.929: «оновити при відкритті». Сторінки банку (списання/надходження) при
 * відкритті просять backend підтягнути виписку через API-підключення
 * організації, якщо остання синхронізація давніша за 10 хв. Запит іде у
 * чергу (темп на банк тримає сервер), тож через кілька секунд оновлюємо
 * списки. Без підключень — backend повертає queued=0, нічого не робимо.
 */
import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { bankApi } from '@/api/bankApi';

const REFRESH_AFTER_MS = 15_000;

export function useBankApiRefreshOnOpen(orgId: string | undefined, onRefreshed?: () => void) {
  const qc = useQueryClient();
  const askedFor = useRef<string | null>(null);
  const cb = useRef(onRefreshed);
  cb.current = onRefreshed;
  useEffect(() => {
    if (!orgId || askedFor.current === orgId) return;
    askedFor.current = orgId;
    let timer: ReturnType<typeof setTimeout> | null = null;
    bankApi.refresh(orgId).then((r) => {
      if (!r.queued) return;
      timer = setTimeout(() => {
        qc.invalidateQueries({ predicate: (q) => String(q.queryKey[0] ?? '').startsWith('bank-') });
        cb.current?.();
      }, REFRESH_AFTER_MS);
    }).catch(() => { /* немає прав/підключень — тихо */ });
    return () => { if (timer) clearTimeout(timer); };
  }, [orgId, qc]);
}
